const getters = {
  endpointIndex: state => state.endpointIndex,
  endpoints: state => networkId => state.endpoints[networkId],
  webEndpoints: state => networkId => state.endpoints[networkId].web,
  socketEndpoints: state => networkId => state.endpoints[networkId].websocket,
  namespaceIndex: state => state.namespaceIndex,
  namespace: state => index => state.namespaces[index],
  namespaces: state => state.namespaces,
  balance: state => state.balance
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js